import MonthRange from './MonthRange';

export default MonthRange;
